import { memo } from 'react';
import { cx } from '@trinity/chat-components/utils';
import styles from './style/Toolbar.module.css';

type Props = {
  className?: string;
} & ChildrenProps;

export const Toolbar = memo(({ children, className }: Props) => {

  return (
    <div className={cx(styles.toolbar, className)}>
      {children}
    </div>
  );
});